import { useEffect, useState } from 'react';

const useDelayedRender = (delay = 200) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setVisible(true), delay);
    return () => clearTimeout(id);
  }, [delay]);

  return visible;
};

export { useDelayedRender };